import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { PoiService } from './poi.service';

export const Ng1PoiModule = angular
  .module('control-room.shared.services.poi', [])
  .factory('crPoiService', downgradeInjectable(PoiService));